import {
  BaseQueryFn,
  EndpointBuilder,
  FetchArgs,
  FetchBaseQueryError,
} from "@reduxjs/toolkit/query";
import { BaseUserResponse } from "@/redux/users/types";

export interface ValidationErrorItem {
  attr: string;
  code: string;
  detail: string;
}

export interface ApiErrorResponse {
  data: {
    errors: ValidationErrorItem[];
  };
  type: string;
}

export interface NormalizedApiError {
  status?: number;
  code?: string;
  detail?: string;
}

export const normalizeApiError = (error: unknown): NormalizedApiError => {
  const { status, data } =
    (error as { status?: number; data?: unknown } | undefined) ?? {};
  const firstError = (data as ApiErrorResponse["data"] | undefined)
    ?.errors?.[0];

  return {
    status,
    code: firstError?.code,
    detail: firstError?.detail,
  };
};

export type RtkQuery<T, C extends BasePaginationQueryParams> = (
  params: C,
) => Promise<{ data?: T[] | PaginatedResponse<T> | undefined }>;

export interface PaginatedResponse<T> {
  count: number;
  next: number | null;
  previous: number | null;
  results: T[];
}

export interface CursorPage<T> {
  next: string | null;
  previous: string | null;
  results: T[];
}

export interface BasePaginationQueryParams {
  page?: number;
  pageSize?: number;
  pagination?: "on" | "off";
}

export interface BaseCursorPaginationQueryParams {
  cursor?: string;
  pageSize?: number;
}

export interface UserAuditResponse {
  createdBy: BaseUserResponse | null;
  updatedBy: BaseUserResponse | null;
}

export interface DateAuditResponse {
  createdAt: string;
  updatedAt: string | null;
}

export type AuditResponse = UserAuditResponse & DateAuditResponse;

export interface BaseData {
  id: number;
}

export interface BaseUUIDData {
  id: string;
}

export type BuilderType<Tags extends string = string> = EndpointBuilder<
  BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError>,
  Tags,
  "commonsApi"
>;

export interface BasePermissions {
  canView?: boolean;
  canCreate?: boolean;
  canEdit?: boolean;
  canDelete?: boolean;
}

export interface BaseFilters {
  orFilters?: string[];
}
